<p *ngIf="!small">ui-loading works!</p>
<ion-spinner *ngIf="small" name="crescent"></ion-spinner>